// extracted by mini-css-extract-plugin
export default {"container":"Suggestions_container__kC69N"};